module.exports = __webpack_public_path__ + "img/2.48639b2f.jpg";